import React from 'react';
/** True when FAQ + CTA are wrapped — shared seal is rendered by `LandingFaqCtaBand`. */
export const FaqCtaSharedSealContext = React.createContext(false);
